module.exports = __webpack_public_path__ + "static/media/automobile.5173a834.jpg";